import { BffApiClientMolecule } from "@/app/api-client/store"
import { computed } from "@reatom/core"
import { molecule } from "bunshi"
import { CollectionMoleculeReatom as CollectionMolecule } from "../store/index.reatom"
import {
  getCollectionOfferGroupsQueryParams,
  getHighestCollectionOffersQueryParams,
} from "./utils"

export const CollectionOfferGroupsMoleculeReatom = molecule((mol) => {
  const { collectionId } = mol(CollectionMolecule)
  const bffApiClient = mol(BffApiClientMolecule)

  const offersQueryParams = computed(
    () => ({
      ...getCollectionOfferGroupsQueryParams(bffApiClient, collectionId),
      refetchInterval: 60000,
    }),
    "offerGroupsQueryParams",
  )

  return { offersQueryParams }
})

export const HighestCollectionOffersMoleculeReatom = molecule((mol) => {
  const { collectionId } = mol(CollectionMolecule)
  const bffApiClient = mol(BffApiClientMolecule)

  const offersQueryParams = computed(
    () => getHighestCollectionOffersQueryParams(bffApiClient, collectionId),
    "highestOffersQueryParams",
  )

  return { offersQueryParams }
})
